export default __webpack_public_path__ + "static/image-two-mobile-6d43c63e99df5dd13f6f2f6ac7e27ad9.png";